import { render, staticRenderFns } from "./TopBar.vue?vue&type=template&id=1af64a6a&scoped=true"
import script from "./TopBar.vue?vue&type=script&lang=js"
export * from "./TopBar.vue?vue&type=script&lang=js"
import style0 from "./TopBar.vue?vue&type=style&index=0&id=1af64a6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af64a6a",
  null
  
)

export default component.exports